import {
  /* Mainnet */
  arbitrum,
  avalanche,
  base,
  bsc,
  linea,
  mainnet,
  mantle,
  optimism,
  polygon,

  /* Testnet */
  arbitrumSepolia,
  avalancheFuji,
  baseSepolia,
  mantleSepoliaTestnet,
  optimismSepolia,
  polygonAmoy,
  sepolia
} from 'wagmi/chains'

export const CHAIN_MAP = {
  /* Mainnet */
  [arbitrum.id]: arbitrum,
  // [avalanche.id]: avalanche,
  [base.id]: base,
  // [bsc.id]: bsc,
  // [linea.id]: linea,
  [mainnet.id]: mainnet,
  [mantle.id]: mantle,
  [optimism.id]: {
    ...optimism,
    name: 'Optimism'
  },
  // [polygon.id]: polygon,

  /* Testnet */
  [arbitrumSepolia.id]: arbitrumSepolia,
  // [avalancheFuji.id]: avalancheFuji,
  [baseSepolia.id]: baseSepolia,
  [mantleSepoliaTestnet.id]: {
    ...mantleSepoliaTestnet,
    name: 'Mantle Sepolia'
  },
  [optimismSepolia.id]: optimismSepolia,
  // [polygonAmoy.id]: polygonAmoy,
  [sepolia.id]: sepolia
}

export const CHAIN_LIST = [
  // Mainnet
  CHAIN_MAP[arbitrum.id],
  // CHAIN_MAP[avalanche.id],
  CHAIN_MAP[base.id],
  // CHAIN_MAP[bsc.id],
  // CHAIN_MAP[linea.id],
  CHAIN_MAP[mainnet.id],
  CHAIN_MAP[mantle.id],
  CHAIN_MAP[optimism.id],
  // CHAIN_MAP[polygon.id],

  // Testnet
  CHAIN_MAP[arbitrumSepolia.id],
  // CHAIN_MAP[avalancheFuji.id],
  CHAIN_MAP[baseSepolia.id],
  CHAIN_MAP[mantleSepoliaTestnet.id],
  CHAIN_MAP[optimismSepolia.id],
  // CHAIN_MAP[polygonAmoy.id],
  CHAIN_MAP[sepolia.id]
]

export const CHAIN_ICON_KEY_MAP = {
  [arbitrum.id]: 'arbitrum',
  [avalanche.id]: 'avalanche',
  [avalancheFuji.id]: 'avalanche',
  [base.id]: 'base',
  [bsc.id]: 'bsc',
  [linea.id]: 'linea',
  [mainnet.id]: 'ethereum',
  [mantle.id]: 'mantle',
  [optimism.id]: 'optimism',
  [polygon.id]: 'polygon',
  [sepolia.id]: 'ethereum',
  [optimismSepolia.id]: 'optimism',
  [baseSepolia.id]: 'base',
  [arbitrumSepolia.id]: 'arbitrum',
  [mantleSepoliaTestnet.id]: 'mantle',
  [polygonAmoy.id]: 'polygon',

  nearMainnet: 'near',
  nearTestnet: 'near'
}
